import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  text: Subject<any> = new Subject<any>();
  labels: Subject<any> = new Subject<any>();
  cookie: Subject<any> = new Subject<any>();
  footer: Subject<any> = new Subject<any>();

  cache: object = {
    pl: {},
    en: {}
  };

  constructor(private http: HttpClient) { }

  checkCache(language: string, content: string, serviceType: string, contentObject?: object): object | boolean {

    content = content.replace(/-/g, '');
    serviceType = serviceType.replace(/-/g, '');

    for (const languageProperty in this.cache) {
      if (languageProperty === language) {
        for (const textObject in this.cache[languageProperty]) {
          if (textObject === content + serviceType) {
            return this.cache[languageProperty][textObject];
          }
        }
        if (contentObject) {
          this.cache[languageProperty][content + serviceType] = contentObject;
          return contentObject;
        }
        return false;
      }
    }
  }

  getText(content: string, language: string, serviceType: string = '') {
    const dataObject: object | boolean = this.checkCache(language, content, serviceType);

    if (dataObject !== false) {
      if (content === 'cookie-alert') {
        this.cookie.next(dataObject);
      } else if (content === 'footer') {
        this.footer.next(dataObject);
      } else { this.text.next(dataObject); }
      return null;
    } else {
      let requestEndPoint: string;
      if (content === 'services') {
        requestEndPoint = `./assets/data/${language}/${content}-${serviceType}.json`;
      } else {
        requestEndPoint = `./assets/data/${language}/${content}.json`;
      }
      this.http.get(requestEndPoint).subscribe(data => {
        if (content === 'cookie-alert') {
          this.cookie.next(data);
        } else if (content === 'footer') {
          this.footer.next(data);
        } else { this.text.next(data); }

        this.checkCache(language, content, serviceType, data);
      });
    }
  }

  getLabels(labels: string, language: string) {
    const dataObject: object | boolean = this.checkCache(language, labels, '');

    if (dataObject !== false) {
      this.labels.next(dataObject);
      return null;
    } else {
      const requestEndPoint = `./assets/data/${language}/${labels}.json`;
      this.http.get(requestEndPoint).subscribe(data => {
        this.labels.next(data);
        this.checkCache(language, labels, '', data);
      });
    }
  }

  textObservable() {
    return this.text.asObservable();
  }

  labelsObservable() {
    return this.labels.asObservable();
  }

  cookieObservable() {
    return this.cookie.asObservable();
  }

  footerObservable() {
    return this.footer.asObservable();
  }
}
